const DESTINATION_SCOPE_BY_KIND = {
    stale_price: 'agreement',
    discount_leak: 'agreement',
    cross_sell: 'client',
    recurring_adhoc: 'client'
};
export const opportunityDestination = (opportunity)=>DESTINATION_SCOPE_BY_KIND[opportunity.kind] === 'agreement' && opportunity.relationshipId != null ? {
        scope: 'agreement',
        relationshipId: opportunity.relationshipId
    } : {
        scope: 'client',
        clientId: opportunity.clientId
    };
